<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>Categories</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <template>
          <v-btn
            data-cy="addUnitBTN"
            color="primary"
            dark
            @click="goAddCategory()"
            >Add Category</v-btn
          >
        </template>
      </v-toolbar>
      <v-skeleton-loader
        v-if="loadingData == true"
        type="table-heading, list-item-two-line, image, table-tfoot"
      ></v-skeleton-loader>
      <TableItmes
        v-else
        :TreeItems="TreeItems"
        v-on:DialogDetailsView="DialogDetailsMethod($event)"
        v-on:deleteDialog="DeleteDialogMethod($event)"
      />
      <DialogDetails
        :DialogDetails="DialogDetails"
        v-on:DialogDetailsClose="DialogDetailsMethodClose($event)"
        :categoryDetails="categoryDetails"
      />
      <DeleteCategory
        :DeleteDialog="DeleteDialog"
        :DeleteItem="DeleteItem"
        v-on:closeDialog="closeDialogMethodClose($event)"
        v-on:renderData="refreshData($event)"
      />
    </v-card>
  </v-container>
</template>
<style >
.status {
  font-size: 20px;
  position: relative;
  top: 9px;
}
</style>

<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
import TableItmes from "@/components/Category/TableItmes";
import DialogDetails from "@/components/Category/dialogDetails";
import DeleteCategory from "@/components/Category/DeleteCategory";

export default {
  data() {
    return {
      loadingData : true ,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/",
        },
        {
          text: "Categories",
          disabled: true,
        },
      ],
      TreeItems: [],
      DialogDetails: false,
      DeleteDialog: false,
      DeleteItem: {},
      categoryDetails: {},
    };
  },
  components: {
    TableItmes,
    Breadcrumbs,
    DialogDetails,
    DeleteCategory,
  },

  mounted() {
    this.getTreeItems();
  },

  methods: {
    DialogDetailsMethod(val) {
      this.categoryDetails = val;
      this.DialogDetails = true;
    },
    DeleteDialogMethod(val) {
      this.DeleteItem = val;
      this.DeleteDialog = true;
    },
    closeDialogMethodClose() {
      this.DeleteDialog = false;
    },
    getTreeItems() {
      this.$store.dispatch("GetFromAPI", "/admin/category").then((response) => {
        this.TreeItems = response["data"]["data"];
        this.loadingData = false
      });
    },
    goAddCategory() {
      this.$router.push({ name: "AddCategory" }).catch(() => {});
    },
    DialogDetailsMethodClose() {
      this.DialogDetails = false;
    },
    refreshData(value) {
      if (value) {
        this.getTreeItems();
      }
    },
  },
};
</script>